const initialState = {
    packages: [],
    packagesPending: false,
    packagesFetched: false,

    userPackages: [],
    userPackagesPending: false,
    userPackagesFetched: false,

    userMeditations: [],
    userMeditationsPending: false,
    userMeditationsFetched: false,

    blankPackage: {
        id: 0,
        meditations: [{
            id: 0,
            title: "",
            duration: 0,
            position: 1,
            userMeditationId: 0,
            createdAt: "1970-01-01T00:00:00+00:00",
            progress: 0,
            completedAt: null,
            completed: false,
            packageId: 0
        }],
        title: "",
        description: "",
        featured: false,
        price: "0",
        meditationsCount: 4,
        completedMeditationsCount: 0
    }
};

const PackagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_PACKAGES_PENDING':
            return Object.assign({}, state, {
                packagesPending: true,
                packagesFetched: false,
            });

        case 'GET_PACKAGES_FULFILLED':
            return Object.assign({}, state, {
                packagesPending: false,
                packagesFetched: true,
                packages: action.payload.filter(p=> {
                    return p.meditationsCount > 0;
                }).map(p => {
                    return {
                        meditations: [],
                        meditationsPending: false,
                        meditationsFetched: false,
                        completedMeditationsCount: 0,
                        ...p
                    };
                })
            });

        case 'GET_PACKAGES_REJECTED':
            return Object.assign({}, state, {
                packagesPending: false,
                packagesFetched: false,
            });

        case 'GET_PACKAGE_PENDING':
            return Object.assign({}, state, {
                packagesPending: true
            });

        case 'GET_PACKAGE_FULFILLED':
            //THIS IS NOT NEEDED
            return state;

        case 'GET_PACKAGE_REJECTED':
            return Object.assign({}, state, {
                packagesPending: false
            });

        case 'GET_PACKAGE_MEDITATIONS_PENDING': {
            let packages = state.packages.slice();

            for (let i = 0; i < packages.length; i++) {
                let p = packages[i];
                if (p.id === parseInt(action.meta.id)) {
                    p.meditationsFetched = false;
                    p.meditationsPending = true;
                }
            }

            return Object.assign({}, state, {
                packagesPending: true,
                packages
            });
        }

        case 'GET_PACKAGE_MEDITATIONS_FULFILLED': {
            let meditations = [];
            const packageId = parseInt(action.meta.id);

            for (let i = 0; i < action.payload.length; i++) {
                let pMed = action.payload[i];
                let uMed = state.userMeditations.find(m => m.id === pMed.id);

                //TODO: refactor
                meditations.push(Object.assign(pMed, uMed, {
                    audioUrl: pMed.audioUrl,
                    packageId: packageId
                }));
            }

            let packages = state.packages.slice();
            for (let i = 0; i < packages.length; i++) {
                let p = packages[i];
                if (p.id === packageId) {
                    p.meditationsFetched = true;
                    p.meditationsPending = false;
                    p.meditations = meditations;
                }
            }

            return Object.assign({}, state, {
                packagesPending: false,
                packages
            });
        }

        case 'GET_PACKAGE_MEDITATIONS_REJECTED':
            let packages = state.packages.slice();
            for (let i = 0; i < packages.length; i++) {
                let p = packages[i];
                if (p.id === parseInt(action.meta.id)) {
                    p.meditationsFetched = false;
                    p.meditationsPending = false;
                }
            }

            return Object.assign({}, state, {
                packagesPending: false
            });

        case 'GET_USER_PACKAGES_PENDING':
            return Object.assign({}, state, {
                userPackagesPending: true,
                userPackagesFetched: false,
                userPackages: []
            });

        case 'GET_USER_PACKAGES_FULFILLED': {

            let packages = state.packages.slice();
            action.payload.forEach(uPack => {
                if (uPack.package.meditationsCount > 0) {
                    let packIndex = packages.findIndex(p => p.id === uPack.package.id);

                    packages[packIndex].completedMeditationsCount = uPack.completedMeditationsCount;
                    packages[packIndex].userPackageId = uPack.id;
                    packages[packIndex].meditations = uPack.package.meditations;
                }
            });

            return Object.assign({}, state, {
                userPackagesPending: false,
                userPackagesFetched: true,
                userPackages: action.payload,
                packages: packages
            });
        }

        case 'GET_USER_PACKAGES_REJECTED':
            return Object.assign({}, state, {
                userPackagesPending: false,
                userPackagesFetched: false,
                userPackages: []
            });

        case 'GET_MEDITATIONS_PENDING':
            return Object.assign({}, state, {
                //loading should not be shown for this after it has been loaded
                userMeditationsPending: !state.userMeditationsFetched,
                userMeditationsFetched: false,
                userMeditations: []
            });

        case 'GET_MEDITATIONS_FULFILLED': {
            let meditations = [];
            let packages = state.packages.slice();
            let uPackages = state.userPackages.slice();

            for (let i = 0; i < action.payload.length; i++) {
                let uMed = action.payload[i];

                const parsedUmedObj = {
                    id: uMed.meditation.id,
                    title: uMed.meditation.title,
                    description: uMed.meditation.description,
                    position: uMed.meditation.position,
                    duration: uMed.meditation.duration,
                    userMeditationId: uMed.id,
                    createdAt: uMed.createdAt,
                    progress: uMed.progress,
                    completedAt: uMed.completedAt,
                    completed: uMed.completed,
                    audioUrl: uMed.meditation.audioUrl,
                    packageId: uMed.meditation.package ? uMed.meditation.package.id : null
                };

                // Merge user-meditations into the packages objects
                for (let j = 0; j < packages.length; j++) {
                    const pack = packages[j];

                    for (let m = 0; m < pack.meditations.length; m++) {
                        let pMed = pack.meditations[m];

                        if (pMed.id === parsedUmedObj.id) {
                            packages[j].meditations[m] = Object.assign(pMed, parsedUmedObj, {
                                audioUrl: pMed.audioUrl
                            });
                            break;
                        }
                    }
                }
                // Merge user-meditations into the user-packages objects
                for (let j = 0; j < uPackages.length; j++) {
                    const pack = uPackages[j].package;

                    for (let m = 0; m < pack.meditations.length; m++) {
                        let pMed = pack.meditations[m];

                        if (pMed.id === parsedUmedObj.id) {
                            uPackages[j].package.meditations[m] = Object.assign(pMed, parsedUmedObj, {
                                audioUrl: pMed.audioUrl
                            });
                            break;
                        }
                    }
                }

                meditations.push(parsedUmedObj);
            }

            return Object.assign({}, state, {
                userMeditationsPending: false,
                userMeditationsFetched: true,
                userMeditations: meditations,
                packages,
                userPackages: uPackages
            });
        }

        case 'GET_MEDITATIONS_REJECTED':
            return Object.assign({}, state, {
                userMeditationsPending: false,
                userMeditationsFetched: false,
                userMeditations: []
            });

        default:
            return state;
    }
};

export default PackagesReducer;


// WEBPACK FOOTER //
// ./src/reducers/Packages.js